<template>
  <div
    class="tutorial"
    v-if="showGoodVatSummaryTutorial"
    @click="setShowGoodVatSummaryTutorial"
  >
    <div class="layout">
      <back-button class="back-button" caption="ย้อนกลับ" />
    </div>
    <div class="t-body">
      <div class="gvsb-title">
        <div class="gvsbt-wrapper">
          <h3>ซื้อสินค้า</h3>

          <div>เราคำนวณให้ว่า..</div>
        </div>
      </div>

      <div class="gvsb-table">
        <div class="gvsbt-row">
          <h4>
            รายละเอียด
          </h4>
          <div class="amount">
            <h4>
              จำนวนเงิน
            </h4>
            <img
              class="fbtcb-icon"
              src="@/assets/icons/bx_bxs-edit.svg"
              alt="phone-square"
            />
          </div>
        </div>
      </div>

      <div class="gvsb-table-background gvsbt-show">
        <div class="mock-up-left">
          <div class="gvsb-table-body">
            <div class="gvsbt-row">
              <div>
                <div>รายได้จากการขายสินค้าต่อปี</div>
              </div>
            </div>
          </div>

          <div class="gvsb-table-body">
            <div class="gvsbt-row">
              <div>
                ภาษีขาย
              </div>
            </div>
          </div>

          <div class="gvsb-table-body">
            <div class="gvsbt-row">
              <div>
                ต้นทุนสินค้าต่อเดือน
              </div>
            </div>
          </div>

          <div class="gvsb-table-body">
            <div class="gvsbt-row">
              <div>
                ภาษีซื้อ
              </div>
            </div>
          </div>

          <div class="gvsb-table-body">
            <div class="gvsbt-row">
              <div>
                ภาษีนำส่ง
              </div>
            </div>
          </div>

          <div class="gvsb-table-body">
            <div class="gvsbt-row">
              <div>
                ภาษีสิ้นปี
              </div>
            </div>
          </div>

          <div class="gvsb-table-body">
            <div class="gvsbt-row">
              <div>
                เงินคงเหลือ
              </div>
            </div>
          </div>

          <div class="gvsb-table-body">
            <div class="gvsbt-row">
              <div>
                สภาพคล่องทางการเงิน
              </div>
            </div>
          </div>

          <div class="gvsb-next">
            <div>
              <chevron-right-link caption="ดูคำอธิบายเพิ่ม" />
            </div>
          </div>
        </div>

        <div class="mock-up-right">
          <div class="gvsb-table">
            <div class="gvsbt-row">
              <div class="amount">
                <h4>
                  จำนวนเงิน
                </h4>
                <img
                  class="fbtcb-icon"
                  src="@/assets/icons/bx_bxs-edit.svg"
                  alt="phone-square"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="frame-right">
          <img src="@/assets/icons/Frame-right.svg" alt="Frame-right" />
        </div>

        <div class="edit-number">
          <img
            src="@/assets/icons/อยากแก้ไขตัวเลข_ คลิกตรงนี้.svg"
            alt="edit-number"
          />
        </div>

        <div class="frame-left">
          <img src="@/assets/icons/Frame-left.svg" alt="Frame-left" />
        </div>

        <div class="dont-understand">
          <img src="@/assets/icons/อ่านไม่เข้าใจ_ คลิกตรงนี้.svg" alt="click" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tutorial",
  components: {},
  data() {
    const goodsType = this.$store.getters["questions/getAnswers"].goodsType;
    const labelIncome = "(รวม VAT)";
    const labelCost = goodsType
      ? "ต้นทุนสินค้าต่อเดือน (รวม VAT)"
      : "ต้นทุนสินค้าต่อเดือน (ไม่รวม VAT)";
    return {
      labelIncome,
      labelCost,
    };
  },
  computed: {
    showGoodVatSummaryTutorial() {
      return this.$store.getters["app/getApp"].showGoodVatSummaryTutorial;
    },
  },
  methods: {
    setShowGoodVatSummaryTutorial() {
      this.$store.dispatch("app/addValue", {
        name: "showGoodVatSummaryTutorial",
        value: false,
      });
    },
  },
};
</script>

<style scoped>
.tutorial {
  width: 100%;
  height: calc(100% + 278px);
  position: absolute;
  top: -56px;
  background: rgb(0, 0, 0, 0.9);

  display: flex;
  flex-direction: column;
  align-items: center;
}
.layout {
  width: 100%;
  padding: 0px 30px;
  max-width: 1120px;
  box-sizing: border-box;
  z-index: -1;
}
.t-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 544px;
  text-align: center;
  position: relative;
  /* margin-top: 34px; */
  margin-bottom: 40px;
}
.gvsb-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  text-align: left;

  padding: 0px 30px;
  box-sizing: border-box;
  visibility: hidden;
}

.gvsb-table {
  width: 100%;
  background: #29a9e2;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
}
.gvsbt-row {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0px 30px;
  box-sizing: border-box;
  visibility: hidden;
}
.gvsbt-row > div {
  text-align: left;
}
.gvsb-table-background {
  width: 100%;
}

.gvsb-table-body {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gvsb-next {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  margin-top: 16px;
  padding: 0px 30px;
  box-sizing: border-box;

  visibility: hidden;
}

.gvsbt-show {
  position: relative;
}

.mock-up-left {
  visibility: visible;
  position: absolute;
  left: 18px;
  width: 253px;
  background: white;
  border-radius: 5px;

  top: 56px;
}
.mock-up-left > div:nth-child(even) {
  background: rgba(41, 169, 226, 0.05);
}
.mock-up-left .gvsbt-row {
  visibility: visible;
  padding-left: 12px;
  white-space: nowrap;
}
.mock-up-left .gvsb-next {
  padding-left: 12px;
}
.mock-up-left .gvsb-next .crl-link {
  visibility: visible;
  white-space: nowrap;
  margin-bottom: 15px;
}

.mock-up-right {
  visibility: visible;
  position: absolute;
  right: 18px;
  width: 150px;
  background: #29a9e2;
  border-radius: 5px;
  top: 2px;
}
.amount {
  display: flex;
  align-items: center;
  width: 150px;
  justify-content: flex-end;
  cursor: pointer;
}
.amount h4 {
  margin-right: 4px;
}
.mock-up-right .gvsbt-row {
  visibility: visible;
  padding: 0px;
  justify-content: flex-end;
  padding-right: 12px;
  height: 50px;
}

.frame-right {
  position: absolute;
  right: 170px;
  top: -70px;
}
.edit-number {
  position: absolute;
  right: 170px;
  top: -115px;
}

.frame-left {
  position: absolute;
  left: 250px;
  top: 450px;
}
.dont-understand {
  position: absolute;
  left: 275px;
  top: 380px;
}
.back-button {
  margin: 24px 0;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .layout {
    padding: 0;
  }
  .back-button {
    margin-bottom: 0;
  }

  .tutorial {
    top: -48px;
    height: calc(100% + 250px);
  }
  .mock-up-left {
    top: 48px;
  }
  .frame-left {
    top: 442px;
  }
  .dont-understand {
    top: 372px;
  }

  .mock-up-right {
    top: -5px;
  }
  .frame-right {
    top: -77px;
  }
  .edit-number {
    top: -122px;
  }
}
</style>
